import { createClient } from '@/shared/api';
import type { CreateRmaTicketMutation, CreateRmaTicketMutationVariables } from '@/shared/api';
import CREATE_RMA_TICKET from '../mutations/createRmaTicket';

/**
 * Creates an RMA ticket from the supplied input. Runs the CREATE_RMA_TICKET mutation, throws createRmaTicket.message when isSuccess is false, and returns the created ticket.
 *
 * @param input - Mutation input payload.
 * @returns The created RMA ticket.
 */
const handleCreateRmaTicket = async (
  input: CreateRmaTicketMutationVariables['input'],
): Promise<NonNullable<CreateRmaTicketMutation['createRmaTicket']>['rmaTicket']> => {
  const client = createClient();
  const result = await client.mutate<CreateRmaTicketMutation, CreateRmaTicketMutationVariables>({
    mutation: CREATE_RMA_TICKET,
    variables: { input },
  });
  const { data } = result;
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { createRmaTicket } = data!;
  if (!createRmaTicket!.isSuccess) {
    throw new Error(createRmaTicket!.message ?? undefined);
  }
  return createRmaTicket!.rmaTicket;
};

export default handleCreateRmaTicket;
